import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Navbar from './Navbar';
import MapaExp from './MapaExp';
import Home from './Home';
import Ode from './Ode';
import Odv from './Odv';
import Val from './Val';
import Cart from './Cart';
import Pomp from './Pomp';
import Tms from './Tms';
import Glosspt from './Glosspt';
import Glossuk from './Glossuk';
import { useState, useEffect } from 'react';


function App() {
    
    const [ling, setLing] = useState('pt');
    const [comp, setComp] = useState('home');
    const [opac, setOpac] = useState('0.5');
    const [menuVisiv, setMenuVisiv] = useState(true);

    const [specs, setSpecs] = useState({
        crit:'Ranking',
        lims: [10, 20, 62, 72],
        dias: 'Úteis',
        anos: '2021 ',
        meses: '2 ',
        horas: '7 8 9 ',
        od: 'Destino',
        est: '',
        la: false,
        az: false,
        verm: false,
        vi: false,
        verd: false,
        tc: true,
        ptc: false,
        am: false,
        tipo: '',
        fer: false,
        nfer: false,
        dmes: '',
        nv: '0',
        veiculos: '',
        ET: false,
        TT: false,
        linhas:'',
        shapes: [],
        res: null
    });

    const varGlob = {
        e: ['FNZ','VNV','CRR','BGM','CPN','RTN','LVD','NVT','NSN','CNT','ANT','CMP','HRM','24A','BLH','TRD',
        'LPA','CML','CMS','FRC','RMD','VSO','SBC','SHR','VGA','EMR','HPH','PRL','CMM','MTS','BCP','MCD','SMT',
        'FCP','CST','ESP','CRT','VRD',
        'PRB','LDD','VPN','MOS','MOC','MOD','MIN','ENA','VAR','ARV','AZR','SCL','VCD','APE','PFR','SBR','PVZ',
        'FCC','CRE','PIA','ARJ','CUS','PQM','FOR','ZIN','MND','CTM','ISM',
        'SOV','DJS','JDE','CMG','GTR','JMO','SBT','ALD','FGM','MRQ','CMB','SLG','PUN','IPO','HSJ',
        'BOT','AER', 'Alt'],
        stationA: ['Fanzeres','Venda Nova','Carreira','Baguim','Campainha','Rio Tinto','Levada','Nau Vitoria',
                'Nasoni','Contumil','Estadio do Dragao','Campanha','Heroismo','24 de Agosto','Bolhao',
                'Trindade','Lapa','Carolina Michaelis','Casa da Musica','Francos','Ramalde','Viso',
                'Sete Bicas','ASra da Hora','Vasco da Gama','Estadio do Mar','Pedro Hispano','Parque de Real',
                'C. Matosinhos','Matosinhos Sul','Brito Capelo','Mercado','BSra da Hora','BFonte do Cuco',
                'Custoias','Esposade','Crestins','BVerdes','Pedras Rubras','Lidador','Vilar do Pinheiro',
                'Modivas Sul','Modivas Centro','Mindelo','Espaco Natureza','Varziela','Arvore','Azurara',
                'Santa Clara','Vila do Conde','Alto de Pega','Portas Fronhas','Sao Bras','CSra da Hora',
                'CFonte do Cuco','Candido dos Reis','Pias','Araujo','Custio','Parque de Maia','Forum',
                'Zona Industrial','Mandim','Castelo da Maia','Santo Ovidio','D. Joao II','Joao de Deus',
                'C.M.Gaia','General Torres','Jardim do Morro','Sao Bento','Aliados','DTrindade',
                'Faria Guimaraes','Marques','Combatentes','Salgueiros','Polo Universitario','I.P.O.',
                'EVerdes','Botica','Modivas Centro','Modivas Norte'],
        stationB: ['Venda Nova','Carreira','Baguim','Campainha','Rio Tinto','Levada','Nau Vitoria','Nasoni',
                'Contumil','Estadio do Dragao','Campanha','Heroismo','24 de Agosto','Bolhao','Trindade',
                'Lapa','Carolina Michaelis','Casa da Musica','Francos','Ramalde','Viso','Sete Bicas',
                'ASra da Hora','Vasco da Gama','Estadio do Mar','Pedro Hispano','Parque de Real',
                'C. Matosinhos','Matosinhos Sul','Brito Capelo','Mercado','Sr. de Matosinhos',
                'BFonte do Cuco','Custoias','Esposade','Crestins','BVerdes','Pedras Rubras','Lidador',
                'Vilar do Pinheiro','Modivas Sul','Modivas Centro','Mindelo','Espaco Natureza','Varziela',
                'Arvore','Azurara','Santa Clara','Vila do Conde','Alto de Pega','Portas Fronhas','Sao Bras',
                'Povoa de Varzim','CFonte do Cuco','Candido dos Reis','Pias','Araujo','Custio','Parque de Maia',
                'Forum','Zona Industrial','Mandim','Castelo da Maia','ISMAI','D. Joao II','Joao de Deus',
                'C.M.Gaia','General Torres','Jardim do Morro','Sao Bento','Aliados','DTrindade',
                'Faria Guimaraes','Marques','Combatentes','Salgueiros','Polo Universitario','I.P.O.',
                'Hospital Sao Joao','Botica','Aeroporto','Modivas Norte','Mindelo'],
        stationAtms: ['Fânzeres','Venda Nova','Carreira','Baguim','Campainha','Rio Tinto','Levada','Nau Vitoria',
                'Nasoni','Contumil','Estádio do Dragão','Campanhã','Heroismo','24 de Agosto','Bolhão',
                'Trindade','Lapa','Carolina Michaelis','Casa da Música','Francos','Ramalde','Viso',
                'Sete Bicas','Sra da Hora','Vasco da Gama','Estádio do Mar','Pedro Hispano','Parque de Real',
                'C. Matosinhos','Matosinhos Sul','Brito Capelo','Mercado','Sra da Hora','Fonte do Cuco',
                'Custoias','Esposade','Crestins','Dos Verdes','Pedras Rubras','Lidador','Vilar do Pinheiro',
                'Modivas Sul','Modivas Centro','Mindelo','Espaço Natureza','Varziela','Árvore','Azurara',
                'Santa Clara','Vila do Conde','Alto da Pêga','Portas Fronhas','S. Bras','Sra da Hora',
                'Fonte do Cuco','Cândido dos Reis','Pias','Araújo','Custió','Parque de Maia','Forum',
                'Zona Industrial','Mandim','Castêlo da Maia','Santo Ovídio','D.João II','João de Deus',
                'C.M.Gaia','General Torres','Jardim do Morro','São Bento','Aliados','Trindade S',
                'Faria Guimaraes','Marques','Lima','Salgueiros','Polo Universitario','I.P.O',
                'Dos Verdes','Botica','Modivas Centro','Modivas Norte'],
        stationBtms: ['Venda Nova','Carreira','Baguim','Campainha','Rio Tinto','Levada','Nau Vitoria','Nasoni',
                'Contumil','Estadio do Dragao','Campanha','Heroismo','24 de Agosto','Bolhao','Trindade',
                'Lapa','Carolina Michaelis','Casa da Musica','Francos','Ramalde','Viso','Sete Bicas',
                'BSra da Hora','Vasco da Gama','Estadio do Mar','Pedro Hispano','Parque de Real',
                'C. Matosinhos','Matosinhos Sul','Brito Capelo','Mercado','Sr. de Matosinhos',
                'BFonte do Cuco','Custoias','Esposade','Crestins','Dos Verdes','Pedras Rubras','Lidador',
                'Vilar do Pinheiro','Modivas Sul','Modivas Centro','Mindelo','Espaco Natureza','Varziela',
                'Arvore','Azurara','Santa Clara','Vila do Conde','Alto da Pega','Portas Fronhas','S. Bras',
                'Povoa de Varzim','CFonte do Cuco','Candido dos Reis','Pias','Araujo','Custio','Parque de Maia',
                'Forum','Zona Industrial','Mandim','Castelo da Maia','ISMAI','D. Joao II','Joao de Deus',
                'C.M.Gaia','General Torres','Jardim do Morro','Sao Bento','Aliados','Trindade S',
                'Faria Guimaraes','Marques','Combatentes','Salgueiros','Polo Universitario','I.P.O',
                'Hospital S. Joao','Botica','Aeroporto','Modivas Norte','Mindelo'],
            coords: [[41.17129167,-8.542754167,41.17509444,-8.541888889],
                [41.17509444,-8.541888889,41.17983389,-8.543498889],
                [41.17983389,-8.543498889,41.18552528,-8.545831389],
                [41.18552528,-8.545831389,41.18334417,-8.553842222],
                [41.18334417,-8.553842222,41.17935889,-8.560211944],
                [41.17935889,-8.560211944,41.17574083,-8.5621725],
                [41.17574083,-8.5621725,41.17410444,-8.573465],
                [41.17410444,-8.573465,41.17065917,-8.577259722],
                [41.17065917,-8.577259722,41.16570139,-8.578657222],
                [41.16570139,-8.578657222,41.16080889,-8.581815833],
                [41.16080889,-8.581815833,41.15075417,-8.585625833],
                [41.15075417,-8.585625833,41.14653778,-8.593006111],
                [41.14653778,-8.593006111,41.14875694,-8.598674167],
                [41.14875694,-8.598674167,41.14977278,-8.605744167],
                [41.14977278,-8.605744167,41.15235167,-8.609205556],
                [41.15235167,-8.609205556,41.15708333,-8.616769444],
                [41.15708333,-8.616769444,41.15855639,-8.621861667],
                [41.15855639,-8.621861667,41.16063417,-8.628673056],
                [41.16063417,-8.628673056,41.16550806,-8.636383333],
                [41.16550806,-8.636383333,41.17293083,-8.641796944],
                [41.17293083,-8.641796944,41.17724083,-8.646523333],
                [41.17724083,-8.646523333,41.18240167,-8.6521725],
                [41.18240167,-8.6521725,41.18808194,-8.654491667],
                [41.18808194,-8.654491667,41.19031222,-8.661041389],
                [41.19031222,-8.661041389,41.18575528,-8.661221667],
                [41.18575528,-8.661221667,41.18033861,-8.666231389],
                [41.18033861,-8.666231389,41.17907972,-8.673576667],
                [41.17907972,-8.673576667,41.18066389,-8.681259167],
                [41.18066389,-8.681259167,41.1801425,-8.688574722],
                [41.1801425,-8.688574722,41.18385639,-8.691455833],
                [41.18385639,-8.691455833,41.18747556,-8.693396111],
                [41.18747556,-8.693396111,41.18819083,-8.685156389],                      
                [41.18808194,-8.654491667,41.19416222,-8.655947778],
                [41.19416222,-8.655947778,41.20026861,-8.655576944],
                [41.20026861,-8.655576944,41.21603972,-8.654554444],
                [41.21603972,-8.654554444,41.23300306,-8.656633611],
                [41.23300306,-8.656633611,41.23817278,-8.658279444],
                [41.23817278,-8.658279444,41.24635028,-8.661838056],
                [41.24635028,-8.661838056,41.25492944,-8.668037778],
                [41.25492944,-8.668037778,41.2702725,-8.679536667],
                [41.2702725,-8.679536667,41.28523278,-8.693544722],
                [41.28523278,-8.693544722,41.29365944,-8.699256667],
                [41.29365944,-8.699256667,41.31505944,-8.714194722],
                [41.31505944,-8.714194722,41.32118667,-8.718667222],
                [41.32118667,-8.718667222,41.33421417,-8.720663333],
                [41.33421417,-8.720663333,41.34034778,-8.725530833],
                [41.34034778,-8.725530833,41.34595333,-8.7280525],
                [41.34595333,-8.7280525,41.35402056,-8.735628611],
                [41.35402056,-8.735628611,41.35907333,-8.739838333],
                [41.35907333,-8.739838333,41.36436778,-8.744918056],
                [41.36436778,-8.744918056,41.36924944,-8.749645556],
                [41.36924944,-8.749645556,41.37320694,-8.753803333],
                [41.37320694,-8.753803333,41.37772083,-8.758232222],
                [41.18808194,-8.654491667,41.19416361,-8.655639167],
                [41.19416361,-8.655639167,41.20070028,-8.649742222],
                [41.20070028,-8.649742222,41.20822139,-8.647142778],
                [41.20822139,-8.647142778,41.21688361,-8.641027778],
                [41.21688361,-8.641027778,41.222295,-8.639020833],
                [41.222295,-8.639020833,41.22912917,-8.626569722],
                [41.22912917,-8.626569722,41.23432694,-8.62395],
                [41.23432694,-8.62395,41.24375278,-8.628488333],
                [41.24375278,-8.628488333,41.25354972,-8.6283525],
                [41.25354972,-8.6283525,41.26272833,-8.617006944],
                [41.26272833,-8.617006944,41.26889389,-8.615402222],
                [41.11548083,-8.606604722,41.1196425,-8.606206111],
                [41.1196425,-8.606206111,41.12607361,-8.605695],
                [41.12607361,-8.605695,41.12965528,-8.606154444],
                [41.12965528,-8.606154444,41.13393583,-8.607516667],
                [41.13393583,-8.607516667,41.13760472,-8.608688889],
                [41.13760472,-8.608688889,41.14460167,-8.610744444],
                [41.14460167,-8.610744444,41.14852639,-8.610980278],
                [41.14852639,-8.610980278,41.15239472,-8.609681111],
                [41.15239472,-8.609681111,41.15734889,-8.609215556],
                [41.15734889,-8.609215556,41.16112333,-8.604476111],
                [41.16112333,-8.604476111,41.16518917,-8.598840556],
                [41.16518917,-8.598840556,41.16934083,-8.598661667],
                [41.16934083,-8.598661667,41.17465111,-8.603624722],
                [41.17465111,-8.603624722,41.18122056,-8.604545278],
                [41.18122056,-8.604545278,41.18296306,-8.601195556],
                [41.23817278,-8.658279444,41.23753778,-8.665198611],
                [41.23753778,-8.665198611,41.23708556,-8.669533333],
                [41.29365944,-8.699256667,41.29364556,-8.702061111],
                [41.29364556,-8.702061111,41.31505944,-8.714194722]],
        m: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
        refLim: {
            "ode": [1000, 500, 200, 100],
            "odv": [200, 100, 25, 5],
            "val": [5000, 2000, 500, 100],
            "cart": [200000, 50000, 10000, 1000],
            "pomp": [[200000, 100000, 50000, 10000],
                        [200000, 100000, 50000, 10000],
                        [200000, 100000, 50000, 10000],
                        [2500, 1500, 500, 250],
                        [2500, 1500, 500, 250],
                        [1500, 750, 250, 100],
                        [1500, 750, 250, 100],
                        [750000, 500000, 250000, 100000],
                        [750000, 500000, 250000, 100000],
                        [75, 50, 25, 5],
                        [75, 50, 25, 5],
                        [75, 50, 25, 5]],
            "tms": [500, 250, 100, 50]
        },
        dsem: ['Dom', 'Seg','Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        lvar: ['Pax AB', 'Pax BA', 'Pax', 'Passagens ET AB', 'Passagens ET BA',  
                'Passagens TT AB', 'Passagens TT BA', 'Lugares AB', 'Lugares BA',
                'Tx Ocupação AB', 'Tx Ocupação BA', 'Max Tx Ocupação'],
        shortvar: ['PaxAB', 'PaxBA', 'Pax', 'ETAB', 'ETBA', 'TTAB', 'TTBA', 'LugAB', 'LugBA', 'pp AB', 
                'pp BA', 'pp max'],
        nomevar: ['pAB', 'pBA', 'p', 'eAB', 'eBA', 'tAB', 'tBA', 'lAB', 'lBA', 'oAB', 'oBA', 'maxto'],
        fvar: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        fvarT: [6, 5, 7, 9, 8, 11, 10, 13, 12, 15, 14, 16],
        shortvartms: ['PassagensAB', 'PassagensBA'],
        nomevartms: ['pAB', 'pBA'],
        urlApp: 'bqmaps-jc.uc.r.appspot.com'
    }

    const mudLing = (l) => {
        setLing(l);
        if (l === 'pt') {
            if (comp === 'glossuk') {
                setComp('glosspt');
                window.location = "/glosspt"
            }
        } else {
            if (comp === 'glosspt') {
                setComp('glossuk');
                window.location = "/glossuk"
            }
        } 
    };
    
    const mudComp = (comp) => {
        setComp(comp);
    };
    
    const mudOpac = (op) => {
        setOpac(op);
        return op;
    };

    useEffect(() => {
        window.localStorage.setItem('ling', 'pt');
    }, []);

    useEffect(() => {
        window.localStorage.setItem('ling', ling);
    }, [ling]);
    
    
    return (
        <div className="App">
        <Navbar ling={ling} comp={comp} setLing={setLing} setComp={setComp} setOpac={setOpac} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />
        { comp !== 'home' && comp !== 'glosspt' && comp !== 'glossuk' && <MapaExp comp={comp} specs={specs} setSpecs={setSpecs} opac={opac} mudOpac={mudOpac} menuVisiv={menuVisiv} varGlob={varGlob} /> }
            <div className="content">
                {comp === 'home' && <Home ling={ling} comp={comp} setComp={setComp} mudLing={mudLing} mudComp={mudComp} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}
                {comp === 'ode' && <Ode ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}
                {comp === 'odv' && <Odv ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}
                {comp === 'val' && <Val ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />} 
                {comp === 'cart' && <Cart ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}
                {comp === 'pomp' && <Pomp ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}  
                {comp === 'tms' && <Tms ling={ling} setLing={mudLing} opac={opac} mudOpac={mudOpac} comp={comp} setComp={setComp} varGlob={varGlob} specs={specs} setSpecs={setSpecs} menuVisiv={menuVisiv} setMenuVisiv={setMenuVisiv} />}
                {comp === 'glossuk' && <Glossuk ling={ling} comp={comp} mudComp={mudComp} mudLing={mudLing}/>}
                {comp === 'glosspt' && <Glosspt ling={ling} comp={comp} mudComp={mudComp} mudLing={mudLing}/>}
            </div>
        </div>
  );
}

export default App;